import Arrow from "@/public/site-assets/svg/cursive-arrow-1.svg";
import FooterWave2Icon from "@/public/site-assets/svg/footer-wave-2.svg";
import clsx from "classnames";
import Link from "next/link";
import { useEffect, useRef, useState } from "react";
import { Container } from "reactstrap";
import styles from "./styles.module.scss";

import { motion } from "framer-motion";
import useLocations from "hooks/useLocations";

export const TextWithOffices = ({
  className,
  heading,
  content,
  showWave,
  waveDirection,
  waveColor,
  waveBackground,
  showTopWave,
  topWaveDirection,
  topWaveColor,
  topWaveBackground,
}) => {
  const post = useLocations();
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.1, // Adjust threshold as needed, make it smaller for more sensitive detection
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      });
    }, options);

    observer.observe(sectionRef.current);

    // Cleanup function
    return () => {
      observer.disconnect();
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const mobileDevice = window.innerWidth <= 991; // Adjust threshold for mobile devices
      // setIsVisible(!mobileDevice); // Hide motion on mobile devices
    };

    handleResize(); // Call initially
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      {showTopWave && (
        <div
          className={clsx(
            "footer",
            topWaveDirection === "down" && "rotate",
            topWaveColor,
            topWaveBackground,
          )}
          style={{ marginBottom: "-1px", zIndex: 1, position: "relative" }}
        >
          <FooterWave2Icon />
        </div>
      )}
      <section ref={sectionRef} className={clsx(className, styles.root)}>
        <Container>
          <div className="wrapper align-items-center">
            <div className="position-relative">
              {heading && <h2 className={`h3 mb-3`}>{heading}</h2>}
              <span className="position-absolute cursive-arrow">
                <Arrow />
              </span>
            </div>
            <div>
              <div className="offset-lg-3 mb-5">
                {content && (
                  <div
                    className={`content focused-text`}
                    dangerouslySetInnerHTML={{ __html: content }}
                  />
                )}
              </div>
              {post?.length >= 1 && (
                <div className="all-locations mt-4">
                  {post.map((post, index) => (
                    <motion.div
                      initial={{ opacity: 0, y: 50 }}
                      animate={isVisible ? { opacity: 1, y: 0 } : {}}
                      transition={{ duration: 0.5, delay: index * 0.1 }}
                    >
                      <Link href={`/contact-us/${post.url_slug}`}>{post.title}</Link>
                    </motion.div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </Container>
      </section>
      {showWave && (
        <div
          className={clsx(
            "footer",
            waveDirection === "down" && "rotate",
            waveColor,
            waveBackground,
          )}
          style={{ marginTop: "-1px" }}
        >
          <FooterWave2Icon />
        </div>
      )}
    </>
  );
};

export default TextWithOffices;
